module.exports = __webpack_public_path__ + "static/media/moistrol-5.4031f79b.jpg";